import { useTranslation } from 'react-i18next';
import type { ErrorDetailsData } from '../../types';

type P = {
  details: ErrorDetailsData;
};

export const useGetEnvironmentItems = ({ details }: P) => {
  const { t } = useTranslation(['translationReactComponents']);
  const { location, timestamp, userAgent } = details;

  return [
    { children: t('dateFormats.dateTime', { date: timestamp }), key: 'time', label: 'Time' },
    { children: location, key: 'page', label: 'Page' },
    { children: userAgent, key: 'browser', label: 'Browser' },
  ];
};
